module.exports = __webpack_public_path__ + "fonts/nexa-light-webfont.3e4574e9.woff2";